import { render, staticRenderFns } from "./rds-charges-stats.vue?vue&type=template&id=9b1eb6c0&scoped=true&"
import script from "./rds-charges-stats.vue?vue&type=script&lang=js&"
export * from "./rds-charges-stats.vue?vue&type=script&lang=js&"
import style0 from "./rds-charges-stats.vue?vue&type=style&index=0&id=9b1eb6c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1eb6c0",
  null
  
)

export default component.exports